import { ValidatorFn } from '@angular/forms';
import { ExtendedFormControl } from '../extended-form-control.class';

export class PasswordControl extends ExtendedFormControl {
    readonly inputType = 'password';

    constructor(name: string, value: string = '', validations: ValidatorFn[] = [], disabled = false) {
        super(name, value, validations, disabled);
    }
}
